import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {HomepageMock} from './mock'

enum LocationStatusEnum {
  未到达 = 0,
  已到达 = 1,
  已领取奖励 = 2,
  未解锁 = 3,
}

export const getHomepageData = createAsyncThunk(
  'getHomepageData',
  async (_, store: any) => {
    // return HomepageMock
    const resp = await http.post(
      '/live/activity/caravan_guards_info',
      {},
      {
        store: window.store,
      }
    )
    return resp.data?.data
  }
)

const initialState: {
  homepage?: {
    err_msg?: string
    start_time?: string
    end_time?: string
    countdown?: number
    mileages_per_forage?: number
    date_list?: string[]
    is_first_visit?: boolean
    forage_balance?: number
    total_mileage?: number
    locations?: {
      location_no?: number
      name?: string
      segment_mileage?: number
      repeatable?: boolean
      max_repeat_times?: number
      rewards?: {
        id?: number
        name?: string
        view_icon?: string
        toast_name?: string
        reward_type?: number
        tag?: string
        privilege_id?: number | null
        origin_id?: number | null
        quantity?: number
        reward_value?: number
        has_show_effect?: boolean
        days?: number | null
      }[]
      status?: number
      current_mileage?: number
      claimed_times?: number
    }[]
    pool_amount?: number
    avatar?: string
    top_rewards?: {
      rank_range?: number[]
      rewards?: {
        id?: number
        name?: string
        quantity?: number
        reward_type?: number
      }[]
    }[]
  }
  claimRewardIdx?: number
} = {
  homepage: {},
  claimRewardIdx: -1,
}

export const CaravanGuardsV3Slice = createSlice({
  name: 'CaravanGuardsV3',
  initialState,
  reducers: {
    setClaimRewardIdx: (state, action) => {
      Object.assign(state, {
        claimRewardIdx: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getHomepageData.fulfilled, (state, action) => {
      const {is_first_visit, locations} = action.payload || {}
      let claimRewardIdx = -1
      if (is_first_visit) {
        claimRewardIdx = 0
      } else {
        claimRewardIdx = locations?.findLast((item) => {
          return item?.status === LocationStatusEnum.已到达
        })?.location_no
      }
      Object.assign(state, {
        homepage: action.payload,
        claimRewardIdx,
      })
    })
  },
})

export default CaravanGuardsV3Slice.reducer
export const CaravanGuardsV3Actions = CaravanGuardsV3Slice.actions
